export enum AuthEnum {
  AZURE_LOGIN_PATH = 'oauth2/authorization/oidc',
  LOGOUT_PATH = 'api/logout'
}
